export default __webpack_public_path__ + "static/media/kanye.726e57e7.jpg";